export default __webpack_public_path__ + "static/media/Cloud.05f8e1d3.png";